import PropTypes from 'prop-types'
import React from 'react'

export const Page = ({children}) => (<section className='main-content'>{children}</section>)

Page.propTypes = {
  children: PropTypes.any
}
